import React, {
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useState,
  useCallback,
} from "react";

import { Grid } from "@mui/material";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { VscWarning } from "react-icons/vsc";

import ConfirmationModal from "../../../Dialogs/ConfirmationModal";
import { Color } from "../../../Form/Button";
import useStyles from "./styles";

interface ConfirmBookModalProps {
  onConfirm: () => void;
  isUpdate?: boolean;
}

export interface ConfirmBookModalHandles {
  open: () => void;
  close: () => void;
}

const ConfirmBookModal: ForwardRefRenderFunction<ConfirmBookModalHandles, ConfirmBookModalProps> = (
  props,
  ref
) => {
  const { onConfirm, isUpdate } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [modalOpened, setModalOpened] = useState<boolean>(false);

  const onOpenModal = useCallback(() => setModalOpened(true), []);
  const onCloseModal = useCallback(() => setModalOpened(false), []);

  useImperativeHandle(ref, () => ({
    open: onOpenModal,
    close: onCloseModal,
  }));

  const onSubmitModal = () => {
    onConfirm();
    setModalOpened(false);
  };

  const confirmAction = isUpdate ? translate("saveAndBook") : translate("createAndBook");
  const submitButtonText = `${translate("yes")}, ${confirmAction}`;

  return (
    <ConfirmationModal
      width="520px"
      open={modalOpened}
      title={confirmAction}
      type="warning"
      closeModal={onCloseModal}
      submit={onSubmitModal}
      textSubmit={submitButtonText}
      showCancelButton
      leftIconTitle={<VscWarning color="#F79009" size={20} />}
      className={classes.modal}
      saveClassName={classes.confirm}
      cancelClassName={classes.cancel}
      customColorSave={Color.WARNING}
    >
      <Grid container direction="column" wrap="nowrap">
        <Grid item xs={12} className={classNames(classes.text, classes.info)}>
          <span>{translate("areYouSureYouWantToConfirmThisBooking")}?</span>
        </Grid>
        <Grid item xs={12} className={classNames(classes.text, classes.warning)}>
          <span>
            {translate("onceConfirmedThisWillBeSentTo")} Maersk,{" "}
            {translate("youAreNotAbleToMakeAnyAdditionalChanges")}.
          </span>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(ConfirmBookModal);
